// src/pages/Gallery.jsx
import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useCart } from '../context/CartContext';
import { LESSON_CATEGORY } from '../catalog';

const fetchPieces = async () => {
  const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;
  if (!apiEndpoint) {
    return [];
  }

  const response = await fetch(`${apiEndpoint}pieces`);
  if (!response.ok) {
    throw new Error('Failed to fetch pieces');
  }
  return response.json();
};

const Gallery = () => {
  const [filter, setFilter] = useState('all');
  const { addProduct } = useCart();
  const { data: pieces, isLoading } = useQuery({
    queryKey: ['pieces'],
    queryFn: fetchPieces
  });

  const shopPieces = pieces?.filter((piece) => piece.category !== LESSON_CATEGORY);

  const categories = ['all', ...new Set(shopPieces?.map((piece) => piece.category))].filter(Boolean);

  const filteredPieces = shopPieces?.filter(piece =>
    filter === 'all' ? true : piece.category === filter
  );

  return (
    <div className="container mx-auto px-4 pt-20 pb-8">
      {/* Filter Controls */}
      <div className="mb-8">
        <div className="flex gap-4 flex-wrap">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setFilter(category)}
              className={`px-4 py-2 rounded-lg transition-colors ${
                filter === category
                  ? 'bg-copper-500 text-linen-50'
                  : 'bg-linen-100 text-walnut-600 hover:bg-linen-200'
              }`}
            >
              {category.charAt(0).toUpperCase() + category.slice(1)}
            </button>
          ))}
        </div>
      </div>
  
 

      {/* Gallery Grid */}
      {isLoading ? (
        <div>Loading...</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredPieces?.map((piece) => (
            <div
              key={piece.id}
              className="bg-linen-50 rounded-lg shadow-md shadow-walnut-900/5 border border-linen-200 overflow-hidden"
            >
              {piece.imageUrl ? (
                <img
                  src={piece.imageUrl}
                  alt={piece.title}
                  className="w-full h-64 object-cover"
                />
              ) : (
                <div className="w-full h-64 flex items-center justify-center bg-linen-100 text-walnut-400">
                  Photo coming soon
                </div>
              )}
              <div className="p-4">
                <h3 className="font-display text-xl font-semibold text-charcoal-900">{piece.title}</h3>
                <p className="text-walnut-600">{piece.description}</p>
                <p className="text-copper-600 font-bold mt-2">
                  {piece.price != null ? `$${piece.price}` : 'Inquire for price'}
                </p>
                {piece.available && piece.price != null && (
                  <button
                    onClick={() => addProduct(piece)}
                    className="mt-4 w-full bg-copper-500 text-linen-50 px-4 py-2 rounded-lg hover:bg-copper-600 transition-colors"
                  >
                    Add to cart
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Gallery;